<template>
    <v-select
        v-if="displayDropdown"
        v-model="selectedCountry"
        :items="shippingCountryItems"
        class="input-no-spacing"
    ></v-select>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    const moduleName = 'ShippingSelector';
    const {mapActions, mapState} = createNamespacedHelpers(moduleName);

    export default {
        name: moduleName,
        created() {
            if (!Object.keys(this.shippingCountries).length) {
                this.loadPossibleShippingCountries();
            }
        },
        props: {
            loadShippingCountries: {
                type: Boolean,
                default: true,
            },
            actualPricesLoaded: {
                type: Boolean,
                default: true,
            },
            displayDropdown: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            ...mapState([
                'shippingCountries',
                'selectedShippingProvider',
            ]),
            selectedCountry: {
                get: function () {
                    return this.$country.getCountryID();
                },
                set: function (countryId) {
                    this.selectedCountryIdChange(countryId);
                }
            },
            getLastBasketChange() {
                return this.$basket.getLastBasketChange();
            },
            shippingCountryItems() {
                const shippingCountries = Object.values(this.shippingCountries);
                return shippingCountries.map(shippingCountry => ({
                    text: shippingCountry.countryName,
                    value: shippingCountry.countryId,
                }));
            },
        },
        methods: {
            ...mapActions([
                'loadPossibleShippingCountries',
                'selectedCountryIdChange',
                'loadMerchantShippingPrices',
            ]),
        },
        watch: {
            shippingCountries: function (data) {
                let fallbackCountry = this.$country.getCountryID();
                let found = false;
                if (this.selectedCountry) {
                    data.some(country => {
                        found = this.selectedCountry == country.countryId;
                        return found;
                    });
                }
                if (!found) {
                    this.selectedCountry = fallbackCountry;
                }
            },
            getLastBasketChange() {
                if (this.actualPricesLoaded) {
                    if (this.loadShippingCountries) {
                        this.loadPossibleShippingCountries().then(() => {
                            this.loadMerchantShippingPrices();
                        });
                    } else {
                        this.loadMerchantShippingPrices();
                    }
                }
            },
            selectedShippingProvider(selectedShippingProvider) {
                if (selectedShippingProvider) {
                    this.loadMerchantShippingPrices();
                }
            },
        },
    };
</script>